import { useState } from 'react';
import { LessonType } from '../../api/lesson';
import { StudentQuestionParamsType } from '../../api/student-question';
import { FilterItem } from '../../components/shared/student-exam-filter/filter';
import { useBooleanState } from './use-boolean-state';

const ALL_ITEM_IDS: ReadonlyArray<string | number> = ['all', 0];

function serializeFilterIds(items: ReadonlyArray<{ id: string | number }>): string | undefined {
  const meaningful = items.filter(item => !ALL_ITEM_IDS.includes(item.id));
  return meaningful.length ? meaningful.map(item => item.id).join(',') : undefined;
}

export type StudentQuestionFiltersReturnType = {
  queryParams: Omit<StudentQuestionParamsType, 'examId' | 'lessonId'>;
  panelProps: {
    selectedLesson: LessonType[];
    setSelectedLesson: React.Dispatch<React.SetStateAction<LessonType[]>>;
    selectedStatus: FilterItem[];
    setSelectedStatus: React.Dispatch<React.SetStateAction<FilterItem[]>>;
    selectedBehaviorState: FilterItem[];
    setSelectedBehaviorState: React.Dispatch<React.SetStateAction<FilterItem[]>>;
    marked: boolean;
    toggleMarked: () => void;
    showAllAnswers: boolean;
    toggleShowAllAnswers: () => void;
  };
  showAllAnswers: boolean;
};

export function useStudentQuestionFilters(): StudentQuestionFiltersReturnType {
  const [selectedLesson, setSelectedLesson] = useState<LessonType[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<FilterItem[]>([]);
  const [selectedBehaviorState, setSelectedBehaviorState] = useState<FilterItem[]>([]);
  const { value: marked, toggle: toggleMarked } = useBooleanState(false);
  const { value: showAllAnswers, toggle: toggleShowAllAnswers } = useBooleanState(false);

  return {
    queryParams: {
      lessonIds: serializeFilterIds(selectedLesson),
      status: serializeFilterIds(selectedStatus),
      behaviorState: serializeFilterIds(selectedBehaviorState),
      marked: marked || undefined
    },
    panelProps: {
      selectedLesson,
      setSelectedLesson,
      selectedStatus,
      setSelectedStatus,
      selectedBehaviorState,
      setSelectedBehaviorState,
      marked,
      toggleMarked,
      showAllAnswers,
      toggleShowAllAnswers
    },
    showAllAnswers
  };
}
